import React, { useEffect } from "react";
import { Button, Col } from "antd";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import {
  AppDispatch,
  syncSystemApiModuleList,
  syncSystemApiModuleListClear,
  syncSystemApiModuleListRequest,
} from "../../../../redux/index";
import {
  schema,
  schemaClear,
  schemaRequest,
} from "@src/redux/slices/schema/get-schema";

const SyncEndPoints: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { loading, result: types } = useSelector(schema);
  const { loading: syncLoading, result: syncSystemApiModule } = useSelector(
    syncSystemApiModuleList
  );

  useEffect(() => {
    if (types && types?.types?.length > 0) {
      const queries =
        types?.types
          ?.find((x: any) => x.name === "Query")
          ?.fields.map((x: any) => x.name) || [];
      const mutations =
        types?.types
          .find((x: any) => x.name === "Mutation")
          ?.fields.map((x: any) => x.name) || [];
      const apiNameList: any[] = [...queries, ...mutations];
      dispatch(schemaClear());
      dispatch(
        syncSystemApiModuleListRequest({
          data: { apiNameList: apiNameList },
        })
      );
    }
  }, [types, dispatch]);
  
  useEffect(() => {
    if (syncSystemApiModule?.status === "success") {
      toast.success(`Endpoints synced successfully`);
      dispatch(syncSystemApiModuleListClear());
    }
  }, [syncSystemApiModule]);

  const handleSyncEndpoints = () => {
    dispatch(schemaRequest({}));
  };

  return (
    <div>
      <Col>
        <Button
          onClick={handleSyncEndpoints}
          loading={loading || syncLoading}
          className="btn-sync"
          type="primary"
        >
          Sync EndPoints
        </Button>
      </Col>
    </div>
  );
};

export default SyncEndPoints;
